import booleanPointInPolygon from '@turf/boolean-point-in-polygon';

export const DEFAULT_MUNICIPIO_AREAS = [
  '/data/geojson/limites/Poly_Palma.geojson',
  '/data/geojson/limites/Poly_Marratxi.geojson'
];

export const DEFAULT_MALLORCA_AREAS = [
  '/data/geojson/limites/Poly_Mallorca.geojson'
];

const geojsonCache = new Map();

const loadGeojson = (ruta) => {
  if (geojsonCache.has(ruta)) {
    return geojsonCache.get(ruta);
  }
  const loader = fetch(ruta)
    .then((res) => res.ok ? res.json() : null)
    .catch(() => null);
  geojsonCache.set(ruta, loader);
  return loader;
};

export const loadGeojsons = async (rutas = DEFAULT_MUNICIPIO_AREAS) => {
  if (!Array.isArray(rutas) || rutas.length === 0) return [];
  const data = await Promise.all(rutas.map((ruta) => loadGeojson(ruta)));
  return data.filter(Boolean);
};

export const loadMunicipioGeojsons = async (rutas = DEFAULT_MUNICIPIO_AREAS) => {
  return loadGeojsons(rutas);
};

const extractMunicipioName = (properties) => {
  if (!properties) return null;
  return (
    properties.Municipio ||
    properties.municipio ||
    properties.MUNICIPIO ||
    properties.municipality ||
    properties.MUNICIPALITY ||
    properties.Name ||
    properties.NAME ||
    properties.nombre ||
    properties.NOMBRE ||
    properties.Descripcion ||
    properties.DESCRIPCION ||
    null
  );
};

export const findMunicipioByPoint = (point, geojsons) => {
  if (!point || !geojsons || geojsons.length === 0) return null;
  const pt = {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [point[1], point[0]],
    },
  };

  for (const geojson of geojsons) {
    if (!geojson) continue;
    if (geojson.type === 'FeatureCollection' && Array.isArray(geojson.features)) {
      for (const feature of geojson.features) {
        if (booleanPointInPolygon(pt, feature)) {
          return extractMunicipioName(feature.properties) || null;
        }
      }
    } else if (
      geojson.type === 'Feature' &&
      (geojson.geometry?.type === 'Polygon' || geojson.geometry?.type === 'MultiPolygon')
    ) {
      if (booleanPointInPolygon(pt, geojson)) {
        return extractMunicipioName(geojson.properties) || null;
      }
    }
  }

  return null;
};

const isPointInGeojsons = (point, geojsons) => {
  if (!point || !geojsons || geojsons.length === 0) return false;
  const pt = {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [point[1], point[0]],
    },
  };

  for (const geojson of geojsons) {
    if (!geojson) continue;
    if (geojson.type === 'FeatureCollection' && Array.isArray(geojson.features)) {
      for (const feature of geojson.features) {
        if (booleanPointInPolygon(pt, feature)) {
          return true;
        }
      }
    } else if (
      geojson.type === 'Feature' &&
      (geojson.geometry?.type === 'Polygon' || geojson.geometry?.type === 'MultiPolygon')
    ) {
      if (booleanPointInPolygon(pt, geojson)) {
        return true;
      }
    }
  }

  return false;
};

export const getMunicipioFromCoords = async (lat, lng, rutas = DEFAULT_MUNICIPIO_AREAS) => {
  if (typeof lat !== 'number' || typeof lng !== 'number') return null;
  const geojsons = await loadMunicipioGeojsons(rutas);
  return findMunicipioByPoint([lat, lng], geojsons);
};

export const isPointInAreasFromCoords = async (lat, lng, rutas = DEFAULT_MUNICIPIO_AREAS) => {
  if (typeof lat !== 'number' || typeof lng !== 'number') return false;
  const geojsons = await loadGeojsons(rutas);
  return isPointInGeojsons([lat, lng], geojsons);
};